const hiddenClass = 'selling_plan_theme_integration--hidden';

class SellingPlansWidget {
  constructor(sellingPlansWidgetContainer) {
    this.enablePerformanceObserver();
    this.sellingPlansWidgetContainer = sellingPlansWidgetContainer;
    this.appendSellingPlanInputs();
    this.updateSellingPlanInputsValues();
    this.listenToVariantChange();
    this.listenToSellingPlanFormRadioButtonChange();
    this.updatePrice();
  }

  get sectionId() {
    return this.sellingPlansWidgetContainer.getAttribute('data-section-id');
  }

  get shopifySection() {
    return document.querySelector(`#shopify-section-${this.sectionId}`);
  }

  get variantIdInput() {
    return (
      this.addToCartForms[1]?.querySelector(`input[name="id"]`) ||
      this.addToCartForms[1]?.querySelector(`select[name="id"]`) ||
      this.addToCartForms[0].querySelector(`input[name="id"]`) ||
      this.addToCartForms[0].querySelector(`select[name="id"]`)
    );
  }

  get priceElement() {
    return this.shopifySection.querySelector('.price');
  }

  get comparedAtPrice() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get visibleSellingPlanForm() {
    return this.shopifySection.querySelector(
      `section[data-variant-id^="${this.variantIdInput.value}"]`,
    );
  }

  get sellingPlanInput() {
    return this.shopifySection.querySelector('.selected-selling-plan-id');
  }

  get addToCartForms() {
    return this.shopifySection.querySelectorAll('[action*="/cart/add"]');
  }

  appendSellingPlanInputs() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.appendChild(this.sellingPlanInput.cloneNode());
    });
  }

  showSellingPlanForm(sellingPlanFormForSelectedVariant) {
    sellingPlanFormForSelectedVariant?.classList?.remove(hiddenClass);
  }

  hideSellingPlanForms(sellingPlanFormsForUnselectedVariants) {
    sellingPlanFormsForUnselectedVariants.forEach((element) => {
      element.classList.add(hiddenClass);
    });
  }

  handleSellingPlanFormVisibility() {
    const sellingPlanFormForSelectedVariant = this.shopifySection.querySelector(
      `section[data-variant-id="${this.variantIdInput.value}"]`,
    );
    const sellingPlanFormsForUnselectedVariants =
      this.shopifySection.querySelectorAll(
        `.selling_plan_theme_integration:not([data-variant-id="${this.variantIdInput.value}"])`,
      );
    this.showSellingPlanForm(sellingPlanFormForSelectedVariant);
    this.hideSellingPlanForms(sellingPlanFormsForUnselectedVariants);
  }

  handleVariantChange() {
    this.handleSellingPlanFormVisibility();
    this.updateSellingPlanInputsValues();
    this.listenToSellingPlanFormRadioButtonChange();
  }

  listenToVariantChange() {
    this.listenToAddToCartForms();
    if (this.variantIdInput.tagName === 'INPUT') {
      const variantIdObserver = new MutationObserver((mutationList) => {
        mutationList.forEach((mutationRecord) => {
          this.handleVariantChange(mutationRecord.target.value);
        });
      });
      variantIdObserver.observe(this.variantIdInput, {
        attributes: true,
      });
    }
  }

  listenToAddToCartForms() {
    this.addToCartForms.forEach((addToCartForm) => {
      addToCartForm.addEventListener('change', () => {
        this.handleVariantChange();
      });
    });
  }

  get regularPriceElement() {
    return this.shopifySection.querySelector('.price__regular');
  }

  get salePriceElement() {
    return this.shopifySection.querySelector('.price__sale');
  }

  get salePriceValue() {
    return this.salePriceElement?.querySelector('.price-item--sale');
  }

  get regularPriceValue() {
    return this.salePriceElement?.querySelector('.price-item--regular');
  }

  get selectedPurchaseOptionPrice() {
    return this.selectedPurchaseOption?.dataset.variantPrice;
  }

  get selectedPurchaseOptionComparedAtPrice() {
    return this.selectedPurchaseOption?.dataset.variantCompareAtPrice;
  }

  updatePrice() {
    if (!this.selectedPurchaseOption) return;
    
    if (
      !this.selectedPurchaseOptionComparedAtPrice ||
      this.selectedPurchaseOptionComparedAtPrice ===
        this.selectedPurchaseOptionPrice
    ) {
      this.showRegularPrice();
      this.hideSalePrice();
      if (this.priceElement) {
        this.priceElement.classList.remove('price--on-sale');
      }
    } else {
      this.showSalePrice();
      this.hideRegularPrice();
      if (this.priceElement) {
        this.priceElement.classList.add('price--on-sale');
      }
    }
  }

  hideSalePrice() {
    if (this.salePriceElement) {
      this.salePriceElement.style.display = 'none';
    }
  }

  hideRegularPrice() {
    if (this.regularPriceElement) {
      this.regularPriceElement.style.display = 'none';
    }
  }

  showRegularPrice() {
    if (this.regularPriceElement) {
      this.regularPriceElement.style.display = 'block';
    }
    const salePriceEl = this.shopifySection.querySelector('.price__sale');
    if (salePriceEl) {
      salePriceEl.style.display = 'none';
    }
  }

  showSalePrice() {
    if (this.salePriceElement) {
      this.salePriceElement.style.display = 'block';
    }
    if (this.regularPriceValue && this.selectedPurchaseOptionComparedAtPrice) {
      this.regularPriceValue.innerHTML = this.selectedPurchaseOptionComparedAtPrice;
    }
    if (this.salePriceValue && this.selectedPurchaseOptionPrice) {
      this.salePriceValue.innerHTML = this.selectedPurchaseOptionPrice;
    }
  }

  get sellingPlanInputs() {
    return this.shopifySection.querySelectorAll('.selected-selling-plan-id');
  }

  updateSellingPlanInputsValues() {
    this.sellingPlanInputs.forEach((sellingPlanInput) => {
      sellingPlanInput.value = this.sellingPlanInputValue;
    });
  }

  get sellingPlanInputValue() {
    return this.selectedPurchaseOption?.dataset.sellingPlanId ?? '';
  }

  get selectedPurchaseOption() {
    return this.visibleSellingPlanForm?.querySelector(
      'input[type="radio"]:checked',
    );
  }

  set selectedPurchaseOption(selectedPurchaseOption) {
    this._selectedPurchaseOption = selectedPurchaseOption;
  }

  handleRadioButtonChange(selectedPurchaseOption) {
    this.selectedPurchaseOption = selectedPurchaseOption;
    this.updateSellingPlanInputsValues();
    this.updatePrice();
  }

  listenToSellingPlanFormRadioButtonChange() {
    this.visibleSellingPlanForm
      ?.querySelectorAll('input[type="radio"]')
      .forEach((radio) => {
        radio.addEventListener('change', (event) => {
          this.handleRadioButtonChange(event.target);
        });
      });
    
    const frequencySelect = this.visibleSellingPlanForm?.querySelector('.selling-plan-frequency-select');
    if (frequencySelect) {
      frequencySelect.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const sellingPlanId = selectedOption.getAttribute('data-selling-plan-id');
        const price = selectedOption.getAttribute('data-price');
        const compareAtPrice = selectedOption.getAttribute('data-compare-at-price');
        
        const radioButton = this.visibleSellingPlanForm?.querySelector(`input[type="radio"][name*="selling_plan"]`);
        if (radioButton) {
          radioButton.value = sellingPlanId;
          radioButton.setAttribute('data-selling-plan-id', sellingPlanId);
          radioButton.setAttribute('data-variant-price', price);
          radioButton.setAttribute('data-variant-compare-at-price', compareAtPrice);
        }
        
        this.updateSellingPlanInputsValues();
        this.updatePrice();
      });
    }
  }

  enablePerformanceObserver() {
    if (typeof PerformanceObserver === 'undefined') return;
    
    const performanceObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (entry.initiatorType !== 'fetch') return;
        const url = new URL(entry.name);
        if (url.search.includes('variant') || url.search.includes('variants')) {
          this.updatePrice();
        }
      });
    });

    try {
      performanceObserver.observe({entryTypes: ['resource']});
    } catch (e) {}
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.selling_plan_app_container')
    .forEach((sellingPlansWidgetContainer) => {
      new SellingPlansWidget(sellingPlansWidgetContainer);
    });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('.selling_plan_app_container')
      .forEach((sellingPlansWidgetContainer) => {
        new SellingPlansWidget(sellingPlansWidgetContainer);
      });
  });
} else {
  document
    .querySelectorAll('.selling_plan_app_container')
    .forEach((sellingPlansWidgetContainer) => {
      new SellingPlansWidget(sellingPlansWidgetContainer);
    });
}
